import { SurveyDto, CopySurveyInput } from './../../../shared/service-proxies/service-proxies';
import { Component, ViewEncapsulation, Injector, OnInit, ViewChild } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DataTable, LazyLoadEvent, Paginator } from 'primeng/primeng';
import { CreateOrEditSurveyModalComponent } from './modals/create-or-edit-survey-modal.component';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { Router } from '@angular/router';
import { SurveysServiceProxy, EventsServiceProxy, ActivateDto } from '@shared/service-proxies/service-proxies';
import { SurveyCategory } from '@shared/AppEnums';
import * as _ from 'lodash';
import * as moment from 'moment';
import { QrCodeModalComponent } from './modals/qrcode-modal.component';

@Component({
    templateUrl: './surveys.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class SurveysComponent extends AppComponentBase implements OnInit {

    surveCategory = SurveyCategory;

    @ViewChild('createOrEditSurveyModal') createOrEditSurveyModal: CreateOrEditSurveyModalComponent;
    @ViewChild('qrCodeModal') qrCodeModal: QrCodeModalComponent;
    @ViewChild('dataTable') dataTable: DataTable;
    @ViewChild('paginator') paginator: Paginator;

    public rootUrl = location.protocol + '//' + location.host;

    //Filters
    filterText = '';
    filterIsActive = undefined;
    filterAnswerRequired = undefined;
    filterSurveyCategory = undefined;
    filterBeginDate = undefined;
    filterEndDate = undefined;
    filterEvent = undefined;
    filterListEvents = [];
    events = [];
    advancedFiltersAreShown = false;

    saving = false;
    downloadingExcel = false;

    constructor(
        injector: Injector,
        private _router: Router,
        private _eventsService: EventsServiceProxy,
        private _fileDownloadService: FileDownloadService,
        private _surveysServiceProxy: SurveysServiceProxy,
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    getSurveys(event?: LazyLoadEvent) {
        if (this.primengDatatableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            return;
        }

        this.primengDatatableHelper.showLoadingIndicator();

        this._surveysServiceProxy.getAll(
            this.filterText,
            this.filterSurveyCategory,
            this.filterEvent ? this.filterEvent.id : undefined,
            this.filterBeginDate,
            this.filterEndDate,
            this.filterIsActive,
            this.filterAnswerRequired,
            this.primengDatatableHelper.getSorting(this.dataTable),
            this.primengDatatableHelper.getSkipCount(this.paginator, event),
            this.primengDatatableHelper.getMaxResultCount(this.paginator, event)
        ).subscribe(result => {
            this.primengDatatableHelper.totalRecordsCount = result.totalCount;
            this.primengDatatableHelper.records = result.items;
            this.primengDatatableHelper.hideLoadingIndicator();
        });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    exportToExcel(): void {
        this.downloadingExcel = true;

        this._surveysServiceProxy.getSurveysToExcel(
            this.filterText,
            this.filterSurveyCategory,
            this.filterEvent ? this.filterEvent.id : undefined,
            this.filterBeginDate,
            this.filterEndDate,
            this.filterIsActive,
            this.filterAnswerRequired,
        )
            .finally(() => {
                this.downloadingExcel = false;
            })
            .subscribe(result => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, true, undefined, undefined, undefined, undefined,undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    createSurvey() {
        this.createOrEditSurveyModal.show();
    }

    deleteSurvey(survey: SurveyDto): void {
        this.message.confirm(
            '',
            this.l('AreYouSure'),
            (isConfirmed) => {
                if (isConfirmed) {
                    this._surveysServiceProxy.delete(survey.id)
                        .subscribe(() => {
                            this.reloadPage();
                            this.notify.success(this.l('SuccessfullyDeleted'));
                        });
                }
            }
        );
    }


    copySurvey(survey: SurveyDto): void {

        let msg = this.l('Survey') + ' ' + survey.title + ' ' + this.l('will be duplicate.');

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {

                    let input = new CopySurveyInput();
                    input.surveyId = survey.id
                    input.eventId = 0;

                    this._surveysServiceProxy.copySurvey(input)
                        .subscribe(() => {
                            this.reloadPage();
                            this.notify.success(this.l('SavedSuccessfully'));
                        });
                }
            }
        );
    }

    clear() {
        this.filterText = '';
        this.filterIsActive = undefined;
        this.filterSurveyCategory = undefined;
        this.filterBeginDate = undefined;
        this.filterEndDate = undefined;
        this.filterEvent = undefined;
        this.filterAnswerRequired = undefined;
    }

    activate(id: number, isActive: boolean): void {

        let model = new ActivateDto();
        model.id = id;
        model.activate = isActive;

        this._surveysServiceProxy.activate(model)
            .subscribe(result => {
                this.reloadPage();
                this.notify.success(this.l('SuccessfullySaved'));
            })
    }

    // Update Begin Date Filter
    upadateFilterBeginDate(value: string) {
        this.filterBeginDate = value ? moment(value, 'L') : undefined;
    }

    // Update End Date Filter
    upadateFilterEndDate(value: string) {
        this.filterEndDate = value ? moment(value, 'L') : undefined;
    }

}



// WEBPACK FOOTER //
// ./src/app/event/surveys/surveys.component.ts